var MpPageBonificacionCarburantes;

(function() {
    if (!document.querySelector('#vue-bonificacion-carburantes-2022')) {
        return;
    }

    MpPageBonificacionCarburantes = new Vue({
        el: '#vue-bonificacion-carburantes-2022',
        mixins: [MpStaticPage],

        data: {
            highlights: [{}, {}, {}, {}],
        },

        methods:{

            getHighlights: function() {
                var news = this.$refs.newsList.querySelectorAll('.js-new'),
                    pos;

                for (var i=0; i<news.length; i++) {
                    pos = parseInt(news[i].dataset.highlight);

                    if (!pos) {
                        continue;
                    }

                    this.highlights.splice(pos-1, 1, {
                        highlight: pos,
                        date: news[i].querySelector('.js-date').getAttribute('datetime'),
                        date_text: news[i].querySelector('.js-date').textContent,
                        title: news[i].querySelector('.js-title').textContent,
                        desc: news[i].querySelector('.js-title').textContent + '- Noticias Sector Petrolíero - Mundopetróleo',
                        image: news[i].dataset.image,
                        url: news[i].querySelector('.js-link').getAttribute('href'),
                    });
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.getHighlights();
            },

        },

    });

})();
